import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

export function CardReviewedByPSC() {
  return (
    <Card className="tw:bg-transparent" size="sm">
      <CardHeader>
        <CardTitle>10. Reviewed by (PSC)</CardTitle>
      </CardHeader>
      <CardContent>
        <p>Awaiting signature</p>
      </CardContent>
    </Card>
  );
}
